module.exports = __webpack_public_path__ + "img/avatar.2dc9c931.jpg";